import { render, staticRenderFns } from "./OnlineProfile.vue?vue&type=template&id=50fbd04b&scoped=true"
import script from "./OnlineProfile.vue?vue&type=script&lang=js"
export * from "./OnlineProfile.vue?vue&type=script&lang=js"
import style0 from "./OnlineProfile.vue?vue&type=style&index=0&id=50fbd04b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbd04b",
  null
  
)

export default component.exports